import React from 'react';
import classNames from 'classnames';
import { Slider as SliderNUI } from '../../../neuro-ui/index';
import { QuestionTypeViewPropTypes } from '../../utils';
import NeuroMessage from '../NeuroMessage';
import { useNeuroMessages } from '../MessageContext';
import {useQuestionContext} from '../QuestionContext';

const Slider = (props) => {
  const { getQuestionAnswersArray } = useQuestionContext();
  const { valueChanged, question, value: { value = [] } = {} } = props;

  const { appkey } = question;

  const messageContext = useNeuroMessages();
  const cssBEM = 'slider';
  const selected = value?.length > 0 ? value[0] : value;

  const extended = false;
  const classes = {};
  classes[`${cssBEM}`] = true;
  classes[`${cssBEM}--non-extended`] = !extended;
  classes[`${cssBEM}--extended`] = extended;

  const selectedAnswerSubtext = selected >= 0 && (
    <NeuroMessage
      id={`${appkey}.${selected}.subtext`}
      className="slider__subtext"
      tagName="span"
      shouldHideIfNotFound={true}
    />
  );

  const answerOptions = (getQuestionAnswersArray({question}) || []).map(
    (answerOption) => {
      return {
        ...answerOption,
        ariaLabel: messageContext.getMessage(answerOption.key),
      };
    }
  );

  return (
    <div>
      <SliderNUI
        name={appkey}
        onChange={valueChanged}
        selected={selected}
        className={classNames(classes)}
        answerOptions={answerOptions}
        extended={extended}
      />
      {selectedAnswerSubtext}
    </div>
  );
};

Slider.propTypes = QuestionTypeViewPropTypes;

export default Slider;
